import { normalizeTime } from "../../../services/misc.functions";

export const GraphCircles: React.FC<{ trainings: any; distances: string[] }> = ({ trainings, distances }) => {
  return (
    <>
      {distances.map((distanceKey, idx) => (
        <div key={`graph-circles-${distanceKey}`} className="col px-0 d-flex justify-content-center">
          {normalizeTime(trainings[0]?.[`training_${distanceKey}m`] ?? null) ? (
            <div className="graph-circle"></div>
          ) : (
            <div className="graph-circle-muted"></div>
          )}
        </div>
      ))}
    </>
  );
};
